import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin, ExternalLink } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-gray-300">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid md:grid-cols-4 gap-8 mb-8">
          {/* Brand */}
          <div>
            <div className="flex items-center space-x-2 mb-4">
              <img src="/images/favicon.webp" alt="ParisPari Hub" className="w-10 h-10" />
              <span className="text-2xl font-bold text-white">ParisPari Hub</span>
            </div>
            <p className="text-sm text-gray-400 leading-relaxed">
              Votre guide de référence pour les meilleurs sites de paris en France. 
              Comparaisons transparentes et analyses indépendantes.
            </p>
            <p>Email : info@parisparihub.com</p>
            <p>Téléphone : +33 4 12 40 70 11</p>
            <p>Adresse : Paris, France</p>
          </div>















          <div className="space-y-3 text-sm font-semibold uppercase tracking-wide">
            <p className="text-xs font-medium uppercase tracking-[0.25em] text-accent">Navigation</p>
            <Link to="/" data-discover="true" itemProp="url" className="block text-sky-100 transition hover:text-primary-red">Accueil</Link>
            <Link to="/guides" data-discover="true" itemProp="url" className="block text-sky-100 transition hover:text-primary-red">Guides</Link>
            <Link to="/reviews" data-discover="true" itemProp="url" className="block text-sky-100 transition hover:text-primary-red">Avis</Link>
            <Link to="/news" data-discover="true" itemProp="url" className="block text-sky-100 transition hover:text-primary-red">Actualités</Link>
          </div>
          <div className="space-y-3 text-sm font-semibold uppercase tracking-wide">
            <p className="text-xs font-medium uppercase tracking-[0.25em] text-accent">Légal</p>
            <Link to="/privacy-policy" data-discover="true" itemProp="url" className="block text-sky-100 transition hover:text-primary-red">Politique de confidentialité</Link>
            <Link to="/terms" data-discover="true" itemProp="url" className="block text-sky-100 transition hover:text-primary-red">Conditions générales</Link>
            <Link to="/cookies" data-discover="true" itemProp="url" className="block text-sky-100 transition hover:text-primary-red">Politique cookies</Link>
            <Link to="/responsible-gaming" data-discover="true" itemProp="url" className="block text-sky-100 transition hover:text-primary-red">Jeu responsable</Link>
          </div>
          <div className="space-y-4 text-sm font-semibold uppercase tracking-wide">
            <p className="text-xs font-medium uppercase tracking-[0.25em] text-accent">Jeu responsable</p>
            <div className="grid grid-cols-2 gap-3">
              <a
                  href="https://www.anj.fr/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center justify-center p-2 bg-gray-800 rounded-lg hover:bg-gray-700 transition"
              >
                <img src="/images/logo-anj.svg" alt="ANJ - Autorité Nationale des Jeux" className="h-12 w-auto object-contain" loading="lazy" decoding="async" />
              </a>
              <a
                  href="https://www.evalujeu.fr/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center justify-center p-2 bg-gray-800 rounded-lg hover:bg-gray-700 transition"
              >
                <img src="/images/evalu.svg" alt="EvaluJeu" className="h-12 w-auto object-contain" loading="lazy" decoding="async" />
              </a>
              <a
                  href="https://www.sosjoueurs.org/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center justify-center p-2 bg-gray-800 rounded-lg hover:bg-gray-700 transition"
              >
                <img src="/images/sos.svg" alt="SOS Joueurs" className="h-12 w-auto object-contain" loading="lazy" decoding="async" />
              </a>
              <a
                  href="https://www.sosjoueurs.org/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center justify-center p-2 bg-gray-800 rounded-lg hover:bg-gray-700 transition"
              >
                <img src="/images/18+.svg" alt="18+" className="h-12 w-auto object-contain" loading="lazy" decoding="async" />
              </a>
            </div>
            </div>




        </div>

        {/* Disclaimer */}
        <div className="border-t border-gray-800 pt-8 mt-8">
          <p className="text-xs text-gray-500 leading-relaxed max-w-4xl">
            ParisPari Hub est un site indépendant de comparaison et d'analyse. Certains liens présents 
            sur nos pages sont des liens d'affiliation, ce qui signifie que nous pouvons recevoir une 
            commission si vous cliquez ou vous inscrivez via ces liens. Cela n'influence jamais nos 
            opinions, analyses ou évaluations. Réservé aux personnes de 18 ans et plus. Jouez de manière 
            responsable - consultez Joueurs-info-service.fr. Les conditions générales s'appliquent.
          </p>
        </div>

        {/* Copyright */}
        <div className="border-t border-gray-800 pt-6 mt-6 flex flex-col md:flex-row justify-between items-center text-sm text-gray-500">
          <p>© 2025 ParisPari Hub. Tous droits réservés.</p>
          <p className="mt-2 md:mt-0">parisparihub.com</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;

